import { Component, Host, Prop, Watch, h } from '@stencil/core';
import { BlogPostPreview } from '../../../../../types/blog';
import { getAssetsURL } from '../../../../../utils/utils';

@Component({
  tag: 'sy-blog-card',
  styleUrl: 'scss/index.scss',
  shadow: true,
})
export class SyBlogCard {
  /**
   * Card's post data
   */
  @Prop() post?: BlogPostPreview;

  /**
   * Post title
   */
  @Prop({ mutable: true }) postTitle = this.post?.title;

  /**
   * Post link
   */
  @Prop({ mutable: true }) link = this.post?.link;

  /**
   * Post category
   */
  @Prop({ mutable: true }) category = this.post?.category;

  /**
   * Post last update date
   */
  @Prop({ mutable: true }) updateDate = this.post?.date;

  /**
   * Post author
   */
  @Prop({ mutable: true }) author = this.post?.author;

  /**
   * Post image's src
   */
  @Prop({ mutable: true, attribute: 'img-src' }) imageSrc = this.post?.img?.src;

  /**
   * Post funnel phase
   */
  @Prop({ mutable: true }) funnelPhase? = this.post?.data?.funnelPhase;

  /**
   * Render card as skeleton
   */
  @Prop() skeleton = false;

  private authorUrl;

  @Watch('post')
  postWatcher(post: BlogPostPreview): void {
    this.postTitle = post?.title ?? this.postTitle;
    this.updateDate = post?.date ?? this.updateDate;
    this.imageSrc = post?.img?.src ?? this.imageSrc;
    this.author = post?.author ?? this.author;
    this.category = post?.category;
    this.link = post?.link;
    this.funnelPhase = post?.data?.funnelPhase;
  }

  async componentWillRender() {
    if (this.author?.photoURL) this.authorUrl = await getAssetsURL(this.author?.photoURL);
  }

  render() {
    if (this.skeleton) {
      return (
        <Host>
          <sy-card type="shadow">
            <sy-card-header>
              <sy-blog-skeleton-load media />
            </sy-card-header>
            <sy-card-content>
              <sy-text type="h6" class="category">
                <sy-blog-skeleton-load style={{ width: '60%' }} />
              </sy-text>
              <sy-text type="h5" class="title">
                <sy-blog-skeleton-load />
              </sy-text>
            </sy-card-content>
            <sy-card-footer>
              <div style={{ width: '32px', height: '32px', borderRadius: '999px' }}>
                <sy-blog-skeleton-load />
              </div>
              <sy-text type="small">
                <sy-blog-skeleton-load style={{ width: '5rem' }} />
              </sy-text>
            </sy-card-footer>
          </sy-card>
        </Host>
      );
    }
    return (
      <Host>
        <sy-card type="shadow" href={this.link}>
          <sy-card-header>
            {this.imageSrc && <img loading="eager" src={this.imageSrc} alt={this.postTitle}></img>}
          </sy-card-header>
          <sy-card-content>
            <sy-text type="h6" class="category">
              {this.category}
            </sy-text>
            <sy-text type="h5" class="title">
              {this.postTitle}
            </sy-text>
          </sy-card-content>
          <sy-card-footer>
            <sy-avatar
              style={{ visibility: this.author ? 'visible' : 'hidden' }}
              small
              rounded
              image={this.author?.photoId && this.authorUrl}
              initials={this.author?.name?.toUpperCase()[0]}
            />
            <sy-text type="small">{this.updateDate}</sy-text>
          </sy-card-footer>
        </sy-card>
      </Host>
    );
  }
}
